import React, { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ScaleLoader } from "react-spinners";
// import dayjs from "dayjs";
import Header from "./Header";
import ApiService from "../services/authservices";
import moment from "moment";
import Tabs from "react-bootstrap/Tabs";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import authservices from "../services/authservices";
import Tab from "react-bootstrap/Tab";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

function Refferal() {
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  useEffect(() => {
    if (i18nextLngs === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
    }
  }, [i18nextLngs]);

  const copyToClipboard = (() => {
    let toastVisible = false;
    return (text) => {
      if (!text) {
        console.warn("No text provided for copying.");
        return;
      }

      if (toastVisible) return;

      if (copyToClipboard.timeout) clearTimeout(copyToClipboard.timeout);

      copyToClipboard.timeout = setTimeout(() => {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            toastVisible = true;
            toast.success(
              <div className="toast-ml">
                <h4 className="toast-title">Success!</h4>
                <p className="toast-message">Copied to clipboard!</p>
              </div>,
              {
                onClose: () => {
                  toastVisible = false;
                },
              }
            );
          })
          .catch((err) => {
            console.error("Failed to copy text:", err);
            toastVisible = true;
            toast.error(
              <div className="toast-ml">
                <h4 className="toast-title">Error!</h4>
                <p className="toast-message">Failed to copy text</p>
              </div>,
              {
                onClose: () => {
                  toastVisible = false;
                },
              }
            );
          });
      }, 300);
    };
  })();

  const [user, setUser] = useState({
    tfaStatus: 0,
    email: null,
    uid: null,
    referralCode: null,
    referralUrl: null,
    displayname: null,
    country: null,
    referralCount: null,
    directReferralCount: null,
    indirectReferralCount: null,
    profits: 0,
    isAuthenticated: false,
  });
  const [loading, setLoading] = useState(true);
  const [loginHistory, setLoginHistory] = useState([]);
  const [historyloading, sethistoryLoading] = useState(true);
  const [currentPageWd, setCurrentPageWd] = useState(1);
  const [loader, setLoader] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [totalPagesWd, setTotalPagesWd] = useState(0);
  const [withdrawalHistory, setWithdrawalHistory] = useState([]);
  const [transactions, setTransactions] = useState([]);

  const [limitWd, setLimitWd] = useState(10);
  const [currentPageDp, setCurrentPageDp] = useState(1);
  const [totalPagesDp, setTotalPagesDp] = useState(0);
  const [limitDp, setLimitDp] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    fetchWithdrawalHistory(currentPageWd, limitWd);
    fetchTransactions(currentPageDp, limitDp);
    fetchLoginHistory(currentPage, limit);
  }, [currentPageWd, limitWd, currentPageDp, limitDp, currentPage, limit]);

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const fetchUserDetails = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const data = await ApiService.getUserDetails(token);
        if (data && data.status) {
          const userDetails = {
            isAuthenticated: true,
            tfaStatus: data.tfastatus,
            email: data.email,
            displayname: data.displayname,
            country: data.country,
            uid: data.uid,
            referralCode: data.referralCode,
            referralUrl: data.referralUrl,
            referralCount: data.referralCount,
            directReferralCount: data.directReferralCount,
            indirectReferralCount: data.indirectReferralCount,
            profits: data.profits,
          };
          setUser(userDetails);
        } else {
          setUser({
            isAuthenticated: false,
            tfaStatus: 0,
            email: null,
            uid: null,
            referralCode: null,
            referralUrl: null,
            referralCount: null,
            directReferralCount: null,
            indirectReferralCount: null,
            profits: 0,
          });
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        setUser({
          isAuthenticated: false,
          tfaStatus: 0,
          email: null,
          uid: null,
          referralCode: null,
          referralUrl: null,
          referralCount: 0,
          directReferralCount: 0,
          indirectReferralCount: 0,
          profits: 0,
        });
      }
    } else {
      setUser({
        isAuthenticated: false,
        tfaStatus: 0,
        email: null,
        uid: null,
        referralCode: null,
        referralUrl: null,
        referralCount: 0,
        directReferralCount: 0,
        indirectReferralCount: 0,
        profits: 0,
      });
    }
    setLoading(false);
  };

  const fetchWithdrawalHistory = async (page, limit) => {
    setLoader(true);
    const response = await authservices.getRewardHistory(page, limit);
    if (response.status) {
      setWithdrawalHistory(response.data);
      setTotalPagesWd(Math.ceil(response.total / limit));
      setLoader(false);
    } else {
      console.error("Failed to fetch withdrawal history:", response.Message);
      setLoader(false);
    }
  };

  const fetchTransactions = async (page, limit) => {
    setLoading(true);
    try {
      const response = await authservices.getReferralRewardHistory(page, limit);
      if (response.status) {
        if (Array.isArray(response.data) && response.data.length > 0) {
          setTransactions(response.data);
          setTotalPagesDp(Math.ceil(response.total / limit));
        } else {
          setTransactions([]);
        }
      } else {
        setTransactions([]);
      }
    } catch (error) {
      console.error("Error fetching reward history:", error);
      setTransactions([]);
      showErrorToast("Failed to load reward history");
    } finally {
      setLoading(false);
    }
  };

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  const handlePageChange = (event, value, eventName) => {
    switch (eventName) {
      case "Login":
        setCurrentPage(value);
        break;
      case "Withdraw":
        setCurrentPageWd(value);
        break;
      case "Deposit":
        setCurrentPageDp(value);
        break;
      default:
        break;
    }
  };

  const handleCopy = (txID) => {
    if (handleCopy.toastVisible) return;

    handleCopy.toastVisible = true;

    if (handleCopy.timeout) clearTimeout(handleCopy.timeout);

    handleCopy.timeout = setTimeout(() => {
      navigator.clipboard
        .writeText(txID)
        .then(() => {
          toast.success(
            <div className="toast-ml">
              <h4 className="toast-title">Success!</h4>
              <p className="toast-message">
                Transaction ID copied to clipboard!
              </p>
            </div>
          );
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
          toast.error(
            <div className="toast-ml">
              <h4 className="toast-title">Error!</h4>
              <p className="toast-message">Failed to copy Transaction ID</p>
            </div>
          );
        })
        .finally(() => {
          setTimeout(() => {
            handleCopy.toastVisible = false;
          }, 2000);
        });
    }, 300); // 300ms debounce time
  };

  const [referralHistory, setReferralHistory] = useState([]);
  const [siteDatacomes, setSiteData] = useState("");

  useEffect(() => {
    fetchReferralHistory();
  }, []);

  useEffect(() => {
    getSitedata();
  }, []);

  const getSitedata = async () => {
    try {
      const data = await ApiService.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) {}
  };

  const fetchReferralHistory = async () => {
    try {
      sethistoryLoading(true);
      const data = await ApiService.getReferralHistory();
      if (data && data.status && Array.isArray(data.referralHistory)) {
        setReferralHistory(data.referralHistory);
        sethistoryLoading(false);
      } else {
        setReferralHistory([]);
        sethistoryLoading(false);
      }
    } catch (error) {
      console.error("Error fetching referral history:", error);
      setReferralHistory([]);
      sethistoryLoading(false);
    }
  };

  const fetchLoginHistory = async (page, limit) => {
    try {
      setLoader(true);
      const response = await authservices.getCollectiveSharingHistory(
        page,
        limit
      );
      if (response.status) {
        setLoginHistory(response.data);
        setTotalPages(Math.ceil(response.total / limit));
        setLoader(false);
      } else {
        console.error(
          "Failed to fetch collective sharing history:",
          response.Message
        );
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching collective sharing history:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const truncateText = (text, maxLength) => {
    if (!text || typeof text !== "string") {
      return "--";
    }
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + " . . .";
    }
    return text;
  };

  return (
    <div>
      <section>
        <Header />
      </section>
      <div className="asset_row_resp">
        <div className="container">
          <div className="home_main">
            <div className="row refer_main">
              <div className="col-lg-6 col-md-6 col-sm-12 refer_left_col">
                <span className="refer_top_left">
                  {" "}
                  {t("Invite&EarnTheRewards")}
                </span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 m-top-20-770 refer_right_col">
                <div className="refer_right_main">
                  <div className="refer_top_innertop">
                    <span className="refer_link_span">
                      {user.referralUrl || "Generating link..."}
                    </span>
                    <div className="refer_cop_div">
                      <i
                        class="ri-file-copy-line cursor-pointer copy_refer"
                        onClick={() => copyToClipboard(user.referralUrl)}
                      ></i>
                    </div>
                  </div>
                  <div className="refer_top_innertop">
                    <span className="refer_link_span">
                      {user.referralCode ? user.referralCode : "Loading..."}
                    </span>
                    <div className="refer_cop_div">
                      <i
                        class="ri-file-copy-line cursor-pointer copy_refer"
                        onClick={() => copyToClipboard(user.referralCode)}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {loading ? (
              <div className="loader_main loader_mainChange">
                <ScaleLoader color="#20A1FD" height={10} width={3} />
                <p>{t("Loading")}</p>
              </div>
            ) : (
              <>
                <div className="row">
                  <div className="col-lg-12 p-0 pad-0-560">
                    <div className="refer_second_main">
                      <span className="refer_myrefer_head">
                        {t("MyReferralAndEarnings")}
                      </span>
                      <div className="row w-100 margin-0">
                        <div className="col-lg-4 pad-0-560">
                          <div className="refer_count_box">
                            <div className="refer_in_top">
                              <img
                                src={require("../assests/icons/refer-earning.png")}
                                alt="Refer"
                                className="refer_icon_inbox"
                              />
                              <span className="top_startgy_inbottomadvance">
                                {" "}
                                {t("YourCumulativeEarnings")}
                              </span>
                            </div>
                            {user.profits != null &&
                            user.profits != undefined ? (
                              <span className="refer_count_number">
                                {user.profits.toFixed(2)} usdt
                              </span>
                            ) : (
                              <span className="refer_count_number">0.00</span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4 pad-0-560 m-top-20">
                          <div className="refer_count_box">
                            <div className="refer_in_top">
                              <img
                                src={require("../assests/icons/refer-teamember.png")}
                                alt="Refer"
                                className="refer_icon_inbox"
                              />
                              <span className="top_startgy_inbottomadvance">
                                {" "}
                                {t("ReferredFriend")}
                              </span>
                            </div>
                            {user.directReferralCount != null &&
                            user.directReferralCount != undefined ? (
                              <span className="refer_count_number">
                                {user.directReferralCount}
                              </span>
                            ) : (
                              <span className="refer_count_number">0</span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4 pad-0-560 m-top-20">
                          <div className="refer_count_box">
                            <div className="refer_in_top">
                              <img
                                src={require("../assests/icons/refer-teamember.png")}
                                alt="Refer"
                                className="refer_icon_inbox"
                              />
                              <span className="top_startgy_inbottomadvance">
                                {" "}
                                {t("TeamMembers")}
                              </span>
                            </div>
                            {user.referralCount != null &&
                            user.referralCount != undefined ? (
                              <span className="refer_count_number">
                                {user.referralCount}
                              </span>
                            ) : (
                              <span className="refer_count_number">0</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="row mb-4">
              <div className="col-lg-12 p-0">
                <div className="refer_third_main pb-0">
                  <div className="manage_btn_row">
                    <span className="home_botstatus_span">
                      {t("RecentReferralHistory")}
                    </span>
                    <Link to="/referralhistory">
                      <div className="d-flex align-items-center gap-2 cursor-pointer">
                        <span className="home_starty_view">{t("ViewAll")}</span>
                        <i class="fa-solid fa-chevron-right home_starty_viewarrow"></i>
                      </div>
                    </Link>
                  </div>
                  <div className="new_referdesi_chn">
                    <div className="table-responsive table-borderless home_recent_table">
                      {historyloading ? (
                        <div className="loader_main loader_mainChange">
                          <ScaleLoader color="#20A1FD" height={10} width={3} />
                          <p>{t("Loading")}</p>
                        </div>
                      ) : (
                        <>
                          <table className="table">
                            <thead>
                              <tr>
                                {/* <th className="text_left">SI.no</th> */}
                                <th>{t("SI.no")}</th>
                                <th>{t("Username")}</th>
                                {/* <th className="text_right">Date & Time</th> */}
                                <th>{t("UserID")}</th>
                                {/* <th>Wallet</th> */}
                                <th>{t("ReferrerID")}</th>
                                {/* <th>Tier</th> */}
                                <th>{t("Date&Time")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {referralHistory.length > 0 ? (
                                referralHistory
                                  .slice(0, 5)
                                  .map((referral, index) => (
                                    <tr key={referral.uuid}>
                                      {/* <td className="text_left"> */}
                                      <td>
                                        <span>{index + 1}</span>
                                      </td>
                                      <td>
                                        <span>{referral.displayname}</span>
                                      </td>
                                      <td>
                                        <span>{referral.referralCode}</span>
                                      </td>
                                      {/* <td>
                                        <span>
                                          {referral.user_wallet.slice(0, 4) +
                                            "..." +
                                            referral.user_wallet.slice(-4)}
                                        </span>
                                      </td> */}
                                      <td>
                                        <span>{referral.referrerId}</span>
                                      </td>
                                      {/* <td>
                                        <span>
                                          {referral.tier.toUpperCase()}
                                        </span>
                                      </td> */}
                                      {/* <td className="text_right"> */}
                                      <td>
                                        <span>
                                          {isNaN(new Date(referral.createdAt))
                                            ? "null"
                                            : moment(referral.createdAt).format(
                                                "lll"
                                              )}
                                          {/* {new Date(referral.createdAt).toLocaleString()} */}
                                        </span>
                                      </td>
                                    </tr>
                                  ))
                              ) : (
                                <tr>
                                  <td colSpan="7" className="text-center">
                                    <span className="depo_no_record">
                                      {t("NoReferralHistoryAvailable")}
                                    </span>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-lg-12 verfication_kyc_col">
                <div className="pad-l-r">
                  <section className="asset_section ref-tab-header">
                    <>
                      <>
                        <Tabs
                          defaultActiveKey="profile"
                          id="uncontrolled-tab-example"
                          className="deposit_accounthead"
                        >
                          <Tab eventKey="profile" title={t("ReferralRewards")}>
                            <div className="row mt-4">
                              <div className="col-lg-12 p-0">
                                <div className="">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <span className="refer_myrefer_head">
                                      {t("ReferralRewards")}
                                    </span>
                                    <div className="table_section home_recent_table mt-3">
                                      <div
                                        className="table_boxcontainer"
                                        style={{ height: "max-content" }}
                                      >
                                        <table>
                                          <thead>
                                            <tr>
                                              {/* <th>Tier Type</th> */}
                                              <th>{t("Date&Time")}</th>
                                              <th>{t("RewardAmount")}</th>
                                              <th>{t("Type")}</th>
                                              {/* <th>Role</th> */}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {transactions.length > 0 ? (
                                              transactions.map(
                                                (transaction, index) => (
                                                  <tr key={index}>
                                                    {/* <td>
                                                      <span>
                                                        {transaction.tierType}
                                                      </span>
                                                    </td> */}
                                                    <td>
                                                      <span>
                                                        {isNaN(
                                                          new Date(
                                                            transaction.createdAt
                                                          )
                                                        )
                                                          ? "null"
                                                          : dayjs(
                                                              transaction.createdAt
                                                            ).format(
                                                              "DD MMMM YYYY, hh:mm A"
                                                            )}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <span>
                                                        {
                                                          transaction.rewardAmount
                                                        }
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <span>
                                                        {transaction.type}
                                                      </span>
                                                    </td>
                                                    {/* <td>
                                                      <span>
                                                        {transaction.isAdmin
                                                          ? "Admin"
                                                          : "User"}
                                                      </span>
                                                    </td> */}
                                                  </tr>
                                                )
                                              )
                                            ) : (
                                              <tr>
                                                <td colSpan="5">
                                                  <span className="depo_no_record d-inline-block my-4">
                                                    {t("NoReferralRewardFound")}
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>

                                        {/* Pagination */}
                                        {totalPagesDp > 1 && (
                                          <div className="pagination history_pagination_all">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={totalPagesDp}
                                                page={currentPageDp}
                                                onChange={(e, value) =>
                                                  handlePageChange(
                                                    e,
                                                    value,
                                                    "Deposit"
                                                  )
                                                }
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>
                          <Tab eventKey="WithdrawHistory" title={t("Rewards")}>
                            <div className="row mt-4">
                              <div className="col-lg-12 p-0">
                                <div className="">
                                  <div className="secuirty_box_contentsub deposit_contentsub">
                                    <span className="refer_myrefer_head">
                                      {t("Rewards")}
                                    </span>
                                    <div className="table_section home_recent_table mt-3">
                                      <div
                                        className="table_boxcontainer"
                                        style={{ height: "max-content" }}
                                      >
                                        <table>
                                          <thead>
                                            <tr>
                                              <th>{t("Currency")}</th>
                                              <th>{t("Data&Time")}</th>
                                              <th>{t("Message")}</th>
                                              <th>{t("Amount")}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {withdrawalHistory.length > 0 ? (
                                              withdrawalHistory.map(
                                                (transaction, index) => (
                                                  <tr key={index}>
                                                    <td>
                                                      <span>
                                                        {transaction.currency}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <span>
                                                        {isNaN(
                                                          new Date(
                                                            transaction.date
                                                          )
                                                        )
                                                          ? "null"
                                                          : dayjs(
                                                              transaction.date
                                                            ).format(
                                                              "DD MMMM YYYY, hh:mm A"
                                                            )}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <span>
                                                        {transaction.message}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <span>
                                                        {transaction.amount}
                                                      </span>
                                                    </td>
                                                  </tr>
                                                )
                                              )
                                            ) : (
                                              <tr>
                                                <td colSpan="5">
                                                  <span className="depo_no_record d-inline-block my-4">
                                                    {t("NoRewardsFound")}
                                                  </span>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>

                                        {totalPagesWd > 1 && (
                                          <div className="pagination history_pagination_all ">
                                            <Stack spacing={2}>
                                              <Pagination
                                                count={totalPagesWd}
                                                page={currentPageWd}
                                                onChange={(e, value) =>
                                                  handlePageChange(
                                                    e,
                                                    value,
                                                    "Withdraw"
                                                  )
                                                }
                                                size="small"
                                                sx={{
                                                  "& .MuiPaginationItem-root": {
                                                    color: "#fff",
                                                  },
                                                  "& .Mui-selected": {
                                                    backgroundColor:
                                                      "#ffc630 !important",
                                                    color: "#000",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#ffc630",
                                                      color: "#000",
                                                    },
                                                  },
                                                  "& .MuiPaginationItem-ellipsis":
                                                    {
                                                      color: "#fff",
                                                    },
                                                  "& .MuiPaginationItem-icon": {
                                                    color: "#fff",
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>
                        </Tabs>
                      </>
                    </>
                  </section>
                </div>
              </div>
            </div>
            <section className="footer_section">
              <div className="container">
                <section className="row mx-0 bn-footer-row g-4 g-lg-1">
                  <div className="col-lg-6 col-sm-6 col-12">
                    <div>
                      <img
                        src={require("./img/footer-logo.webp")}
                        alt=""
                        className="bn-footer-logo"
                      />
                      <p className="bn-footer-logo-content">
                        {t("AIPoweredCryptoTrading")}
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-4 col-6">
                    <h6 className="bn-footer-link-title">{t("Explore")}</h6>
                    <ul className="bn-footer-lists">
                      {/* <li>
                        <Link to="/" className="bn-footer-links">
                          Newbies
                        </Link>
                      </li>
                      <li>
                        <Link to="/" className="bn-footer-links">
                          Knowledge Base
                        </Link>
                      </li>
                      <li>
                        <Link to="/" className="bn-footer-links">
                          Strategies
                        </Link>
                      </li> */}
                      <li>
                        <Link to="/termscondition" className="bn-footer-links">
                          {t("TermsAndService")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/privacypolicy" className="bn-footer-links">
                          {t("PrivacyPolicy")}
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <div className="col-lg-2 col-sm-6 col-6">
                    <h6 className="bn-footer-link-title">{t("Support")}</h6>
                    <ul className="bn-footer-lists">
                      {/* <li>
                                   <Link to="/" className="bn-footer-links">
                                     Terms & Conditions
                                   </Link>
                                 </li>
                                 <li>
                                   <Link to="/" className="bn-footer-links">
                                     Privacy Policy
                                   </Link>
                                 </li> */}
                      <li>
                        <Link to="/support" className="bn-footer-links">
                          {t("HelpCenter")}
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-2 col-sm-6 col-6">
                    <h6 className="bn-footer-link-title">{t("Social")}</h6>
                    <ul className="bn-footer-icon-wrap">
                      <li>
                        <a target="_blank" href={siteDatacomes.instagram}>
                          <img src={require("./img/instagram.webp")} alt="" />
                        </a>
                      </li>
                      <li>
                        <a target="_blank" href={siteDatacomes.twitter}>
                          <img src={require("./img/x.webp")} alt="" />
                        </a>
                      </li>
                      <li>
                        <a target="_blank" href={siteDatacomes.telegram}>
                          <img src={require("./img/telegram.webp")} alt="" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </section>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Refferal;
